import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import clsx from "clsx";

import { IconButton, Tooltip, Popover } from "@mui/material";

import {
	dataRemoveAllFilters
} from "../../redux/data/dataActions";

import EnhancedTable from "./FilterLayout";

export default function ClearAllFiltersBtn() {
	const dispatch = useDispatch();

	const filters = useSelector(state => state.data.filters);
	const allFields = useSelector(state => state.data.fields);
	const allAliases = useSelector(state => state.data.aliases);
    const persist = useSelector(state => state.persist);

	const themeLight = persist.themeLight;

	// Component State
	const [anchorEl, setAnchorEl] = useState(null);
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const filter = filters.find(filter => filter.id !== "-2112" && !filter.hidden);

		if (filter) {
			setVisible(true);
		} else {
			setVisible(false);
			setAnchorEl(null);
		}
	}, [filters]);

	const clearAllFilters = () => {
		dispatch(dataRemoveAllFilters());
	};

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const popoverId = open ? 'simple-popover' : undefined;

	const PopoverStyle = {
		top: '8px'
	};

    /**
     * Set the background and color of the filter icon
     * depends on the current selected theme.
     * @returns {Object} style - contains background and text color of the app bar.
     */
	 const currentStyle = () => {
        return themeLight ? {
            color: "#5c5c5c"
        } : {
            color: "fff"
        }
    }

	if (visible) {
		return (
            <React.Fragment>
				<Tooltip title="All Filters" arrow placement="bottom">
					<IconButton aria-label="delete" onClick={handleClick} size="large">
						<span className={clsx('fa-stack')} style={{verticalAlign: 'top', height: '24px', width: '24px'}}>
							{/*<i className={clsx('fas fa-filter fa-stack-1x')} style={{fontSize: '18px', lineHeight: '28px', paddingRight: '5px'}}></i>*/}
							<i className={clsx('fas fa-filter fa-stack-1x')} style={{fontSize: '20px', color: currentStyle(), lineHeight: '28px', paddingRight: '5px'}}></i>
							<i className={clsx('fas fa-circle fa-stack-2x')} style={{fontSize: '12px', color: 'white', paddingTop: '13.5px', paddingLeft: '10px'}}></i>
						  	<i className={clsx('fas fa-minus-circle fa-stack-2x')} style={{fontSize: '10px', color: 'red', paddingTop: '15px', paddingLeft: '10px'}}></i>
						</span>
					</IconButton>
				</Tooltip>

				<Popover
					id={popoverId}
					open={open}
					anchorEl={anchorEl}
					onClose={handleClose}
					style={PopoverStyle}
					anchorReference="anchorEl"
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
				>
					<EnhancedTable filters={filters} fields={allFields} aliases={allAliases}/>
				</Popover>
			</React.Fragment>
        );
	} else {
		return null;
	}
}
